import React from 'react';
import {Trans} from 'react-i18next';
import {Entry, TimelineEntry, formatDate} from './Shared';

export const DocumentUploadedTimelineEntry = ({entry}) => {
    return (
        <TimelineEntry entry={entry} status="complete" icon="uploadFile">
            <Entry.Title>
                <Trans
                    i18nKey="warehousing.timeline.DocumentUploaded.title"
                    values={{
                        name: entry.fileName,
                        customer: entry.customerName,
                        dataCount: entry.insertedOrUpdatedDataCount,
                        fromDate: formatDate(entry.fromDate),
                        toDate: formatDate(entry.toDate),
                    }}
                    components={{
                        fileLink: <a href={entry.downloadUrl} target="_blank" rel="noopener noreferrer" download />,
                    }}
                />
            </Entry.Title>
        </TimelineEntry>
    );
};
